import { render, staticRenderFns } from "./ProductScanner.vue?vue&type=template&id=67e072d6&scoped=true"
import script from "./ProductScanner.vue?vue&type=script&lang=ts"
export * from "./ProductScanner.vue?vue&type=script&lang=ts"
import style0 from "./ProductScanner.vue?vue&type=style&index=0&id=67e072d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67e072d6",
  null
  
)

export default component.exports